// Maps technical errors to user-friendly French messages.
// Add new patterns here as needed; regex tested against error.message.

type ErrorMapping = {
  pattern: RegExp;
  userMessage: string;
  hint?: string;
};

const MAPPINGS: ErrorMapping[] = [
  {
    pattern: /network|failed to fetch|fetch failed|load failed/i,
    userMessage: "Problème de connexion réseau. Vérifiez votre connexion internet.",
  },
  {
    pattern: /timeout|timed out/i,
    userMessage: "La requête a pris trop de temps. Merci de réessayer.",
  },
  {
    pattern: /jwt|invalid token|token.*expired/i,
    userMessage: "Votre session a expiré. Merci de vous reconnecter.",
  },
  {
    pattern: /row.level security|violates row-level security|new row violates/i,
    userMessage: "Vous n'avez pas les droits pour cette action.",
  },
  {
    pattern: /duplicate key|already exists|unique constraint/i,
    userMessage: "Cette donnée existe déjà.",
  },
  {
    pattern: /not.found|no rows|does not exist/i,
    userMessage: "La ressource demandée est introuvable.",
  },
  {
    pattern: /stripe|payment|card/i,
    userMessage: "Un problème est survenu lors du paiement.",
    hint: "Vérifiez vos informations bancaires ou réessayez plus tard.",
  },
  {
    pattern: /cancellation_window_closed/i,
    userMessage: "Il est trop tard pour annuler ce rendez-vous (moins de 24h).",
  },
  {
    pattern: /rate.?limit|too many requests/i,
    userMessage: "Trop de requêtes. Merci de patienter quelques instants.",
  },
];

export function getUserFriendlyMessage(errorMessage: string): { message: string; hint?: string } {
  for (const m of MAPPINGS) {
    if (m.pattern.test(errorMessage)) {
      return { message: m.userMessage, hint: m.hint };
    }
  }
  return { message: "Une erreur inattendue s'est produite." };
}
